import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { AREA_LIST } from "@/lib/areas";
import { useLang } from "@/lib/i18n";

export const AreasSection = () => {
  const { t } = useLang();
  return (
    <section className="areas-section" id="areas">
      <div className="section-heading">
        <div>
          <div className="eyebrow">{t.areas.eyebrow}</div>
          <h2>{t.areas.title}</h2>
        </div>
        <p>{t.areas.intro}</p>
      </div>
      <div className="areas-grid">
        {AREA_LIST.map((area, i) => (
          <motion.div
            key={area.slug}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.55, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
          >
            <Link className="area-card" to={`/areas/${area.slug}`} data-testid={`area-card-${area.slug}`}>
              <span className="area-km">{area.km}</span>
              <h3>{area.name}</h3>
              <p>{t.areas.blurbs[area.slug]}</p>
              <span className="text-link">
                {t.areas.link} <ArrowUpRight size={15} />
              </span>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
